import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";

const TravelCost = () => {

    return (
        <Fragment>
            <Outlet />
        </Fragment>
    )
};

export default TravelCost;
